import FAQList from "./FAQList";

const FAQ = () => {
    return (
        <section className="flex flex-row items-center w-full justify-center mq450:h-auto bg-white">
        <div id="faq" className="flex flex-row mq450:flex-col items-start max-w-[1280px] w-full justify-between px-[24px] gap-[56px] mq450:px-4  mq450:gap-[32px] h-full py-[96px] mq450:py-[32px]">
        <div id="top" className="flex flex-col mq450:flex-col gap-[32px] mq450:gap-[24px] justify-center items-end w-3/5 mq450:w-full">
            <div id="left" className="flex flex-col w-full gap-[12px]">
                <div id="title" className='font-silka-semibold font-[600] text-[16px] leading-[130%] text-[#362F5B] mq450:text-[14px] uppercase'>FAQ</div>
                <div id="subtitle" className='font-silka-semibold font-[600] text-[40px] leading-[130%] text-[#362F5B] mq450:text-[24px]'>Najczęściej <br />zadawane pytania</div>
            </div>
            <div id="right" className="w-auto">
            <div id='text' className='text-[18px] font-silka-semibold font-[300] text-[#362F5B]'>Masz pytania? Zobacz, co najczęściej interesuje naszych klientów. Jeśli nie znajdziesz odpowiedzi — skontaktuj się z nami, chętnie pomożemy!</div>
            </div>
        </div>
        <FAQList />
        </div>
      </section>
    );
  };
  
  export default FAQ;
  